import { Card, Divider, Stack } from "@mui/material";
import { createEmailTemplate } from "backend/api/emailing";
import EmailPreview from "components/emailing/EmailPreview/EmailPreview";
import { EmailTemplateForm } from "components/emailing/EmailTemplate/EmailTemplateForm/EmailTemplateForm";
import { toastEmitter } from "helpers/helpers";
import { useError } from "hooks/useError";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { NewEmailTemplate } from "types/emailTemplate.type";
import "./CreateEmailTemplate.css";

export function CreateEmailTemplate() {
  const [template, setTemplate] = useState<NewEmailTemplate | null>(null);

  const { t } = useTranslation("emailing");
  const { onError } = useError(t, "emailing.createError");

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { isLoading, mutate: createTemplate } = useMutation({
    mutationFn: (newTemplate: NewEmailTemplate) =>
      createEmailTemplate(newTemplate),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["email-templates"] });
      navigate(`../${data.data.id.toString()}`, { replace: true });
      toastEmitter(t("success.templateCreated"), "success");
    },
    onError,
  });

  return (
    <Card>
      <Stack direction={{ xs: "column", lg: "row" }} spacing={4}>
        <Stack className="container-stack">
          <EmailTemplateForm
            loading={isLoading}
            onSubmit={createTemplate}
            onChange={setTemplate}
          />
        </Stack>
        <Divider
          sx={{
            borderLeftWidth: 1,
          }}
        />
        <Stack className="container-stack">
          {template && template.triggerEvent && (
            <EmailPreview template={template} />
          )}
        </Stack>
      </Stack>
    </Card>
  );
}
